import getEnv from '@/utils/env';


export default {
    getUrl() {
        return getEnv('VUE_APP_QSC_ADMIN_UI_URL');
    },
    getVersion() {
        return getEnv('VUE_APP_QSC_ADMIN_UI_API_VERSION');
    }
}
